import {ROUTES, YAPRoute} from '../../../app.routes';
import {UntypedFormArray, UntypedFormGroup} from '@angular/forms';
import {isDevMode} from '@angular/core';
import {AuthenticationService} from '../../service/authentication.service';
import {EnvironmentService} from '../../service/environment.service';

export abstract class ASecureForm
{
    routes = ROUTES;

    protected constructor(
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService)
    {
    }

    hasRouteAccess(route: YAPRoute)
    {
        return this.hasPrivilege(route.privilege);
    }

    hasPrivilege(privilege: string)
    {
        return this.authenticationService.hasPrivilege(privilege);
    }

    getAllErrors(form: UntypedFormGroup | UntypedFormArray): { [key: string]: any; } | null
    {
        let hasError = false;
        const result = Object.keys(form.controls).reduce((acc, key) =>
        {
            const control = form.get(key);
            const errors = (control instanceof UntypedFormGroup || control instanceof UntypedFormArray)
                ? this.getAllErrors(control)
                : control.errors;
            if (errors)
            {
                acc[key] = errors;
                hasError = true;
            }
            return acc;
        }, {} as { [key: string]: any; });
        return hasError ? result : null;
    }

    isDeveloperMode()
    {
        return false;
    }

    debugOutput(message: string, o: object = null)
    {
        if (isDevMode())
        {
            console.log(message, o);
        }
    }

    isGuestAdminUser(): boolean
    {
        return this.authenticationService.isGuestAdminUser();
    }

    isAdminUser(): boolean
    {
        return this.authenticationService.isAdminUser();
    }
}